
























import ThgBillingPartnerList from "@/components/thg/ThgBillingPartnerList.vue";
import ThgBillingNumberPartnerDetail from "@/components/thg/ThgBillingNumberPartnerDetail.vue";
import TheLayoutPortalSplit from "@/layouts/TheLayoutPortalSplit.vue";
import PaginationListVueMixin from "@/mixins/PaginationListViewMixin.vue";
import { Component } from "vue-property-decorator";
import { PartnerBillingModule } from "@/store/modules/partner-billing.store";
import { BillingTypeEnum } from "@/lib/enum/billingType.enum";
import { handleError } from "@/lib/utility/handleError";
import { mixins } from "vue-class-component";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: {
    TheLayoutPortalSplit,
    ThgBillingPartnerList,
    ThgBillingNumberPartnerDetail
  }
})
export default class ThgBillingPartnerListView extends mixins(PartnerFallbackMixin, PaginationListVueMixin) {
  isLoadingDetail = false;
  isLoading = false;
  billingType = BillingTypeEnum.CREDIT_PARTNER;

  getModule() {
    return PartnerBillingModule;
  }

  get partner() {
    return PartnerModule.partner;
  }

  async updateBillingType(billingType: BillingTypeEnum) {
    this.billingType = billingType;
    await this.loadAll(billingType);
  }

  async mounted() {
    this.isLoading = true;
    try {
      await this.trySetByRouteOrDefault();

      await this.loadAll(BillingTypeEnum.CREDIT_PARTNER);
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  async loadAll(billingType: BillingTypeEnum) {
    this.isLoadingMore = true;

    try {
      await this.refresh({ partnerId: PartnerModule.partner.id, billingType }).catch(handleError);

      const billing = this.getModule().paginationList[0];
      if (billing) {
        await PartnerBillingModule.loadDocument({
          partnerId: PartnerModule.partner.id,
          billingNumber: billing.billingNumber
        }).catch(handleError);
      } else {
        PartnerBillingModule.emptyDocument();
      }
    } finally {
      this.isLoadingMore = false;
    }
  }

  async set(item: any) {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.$router.push({
        name: "ThgBillingNumberPartnerDetailView",
        params: { partnerId: this.$route.params.partnerId, billingNumber: item.billingNumber }
      });
    } else {
      try {
        this.isLoadingDetail = true;
        await PartnerBillingModule.loadDocument({
          partnerId: PartnerModule.partner.id,
          billingNumber: item.billingNumber
        });
      } catch (e) {
        handleError(e);
      } finally {
        this.isLoadingDetail = false;
      }
    }
  }
}
